import React from 'react';

import { useOnClose } from '@core/js/components/common/PopupManager';

import { I18n } from '@interlayer/js/components/common/I18n';
import { ManagedPopup } from '@interlayer/js/components/common/Popup/ManagedPopup';

import { useTranslations } from '@core/js/hooks/i18n';

import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { useNavigate } from '@interlayer/js/hooks/navigate';

import style from './DuplicateAccountPopup.scss';

export const DuplicateAccountPopup: React.FC<{ id: string }> = ({ id }) => {
    const navigate = useNavigate();
    const onClosePopup = useOnClose(id);
    const t = useTranslations('playtech.mobile.system.duplicateAccountPopup.');

    const [dTagDuplicateAccountPopupButtonUrl = '/forgotten-password'] = useDynamicTags([
        DYNAMIC_TAG_NAMES.duplicateAccountPopupButtonUrl
    ]);

    const handlerOpenPopup = () => {
        onClosePopup();
        navigate(dTagDuplicateAccountPopupButtonUrl);
    };

    return (
        <ManagedPopup
            withLogo
            fullscreen
            title={t('title')}
            onClose={onClosePopup}
            className={style.modal}
            classNames={{ inner: style.inner }}
            buttons={[{
                text: t('button.title'),
                className: style.btn,
                view: 'primary',
                size: 'medium',
                onClick: handlerOpenPopup
            }]}
        >
            <div className={style.modalContent}>
                <I18n
                    t={t}
                    tKey="content"
                />
            </div>
        </ManagedPopup>
    );
};
